module.exports = __webpack_public_path__ + "img/yellowEXPanAlert.4bfd13af.svg";